// Claude: Admin AI KB for Buyers — ai_buyer type entries 15-03-2026
import React from "react";
import KnowledgeBasePage from "./KnowledgeBasePage";

const HINT = `To show a tappable button in the AI chat, wrap the option text with <button> tags. Example: <button>Know more about AFTR</button>`;

const AIKnowledgeBuyers = () => <KnowledgeBasePage type="ai_buyer" title="AI Knowledge Base — Buyers" hint={HINT} />;

export default AIKnowledgeBuyers;
